import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  ADBS_RESTART_POLL_DELAY,
  ADBS_RESTART_POLL_INTERVAL,
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface AdbsRestartProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const AdbsRestart = (
  { location, databaseId, onExecute }: AdbsRestartProps,
): JSX.Element => {
  const { invokeCall: invokeRestart } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).adbsDatabaseApi.restartAdbsDatabase },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resGroup = decodeURIComponent(resourceGroup || "");
    const resName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.restartAdbs(),
          message: Messages.notifications.inProgress.messages.restartAdbs(resName),
        },
        success: {
          title: Messages.notifications.success.titles.restartAdbs(),
          message: Messages.notifications.success.messages.restartAdbs(resName),
        },
        failure: {
          title: Messages.notifications.failure.titles.restart(),
          message: Messages.notifications.failure.messages.restartAdbs(resName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.ADBS_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName: resGroup,
            databaseName: resName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.ADBS_RESTART_CHECK,
          delay: ADBS_RESTART_POLL_DELAY,
          interval: ADBS_RESTART_POLL_INTERVAL,
        },
      },
    };
    invokeRestart({
      subscriptionId,
      resourceGroupName: resGroup,
      databaseName: resName,
    }, invokeOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newAdbsRestart = (
  props: AdbsRestartProps,
): JSX.Element => (<AdbsRestart {...props} />);
